/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItems_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_item">;
    readonly " $refType": "PdpRespSellerItems_item";
};
export type PdpRespSellerItems_item$data = PdpRespSellerItems_item;
export type PdpRespSellerItems_item$key = {
    readonly " $data"?: PdpRespSellerItems_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSellerItems_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItems_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = 'e3e19bc8297c9d7b9fb635dd7d9200e2';
export default node;
